import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import EntitySearch from './entity_search'
import ConcurrencyLimitColumn from './concurrency_limit_column'

/* Search-then-edit form for a user's/org's Data Pulse concurrency min/max, below the fair-usage
 * breakdown table. Search picks the entity; both scope columns then show at once. */
const ConcurrencyLimitEditor = ({ client }) => {
  const operatorId = useSelector((state) => state.user.id)

  const [selectedEntity, setSelectedEntity] = useState(null)

  return (
    <div>
      <EntitySearch
        client={client}
        onSelect={setSelectedEntity}
      />
      {selectedEntity && (
        <div className='dpfu-editor-columns'>
          <div className='dpfu-editor-column'>
            <h3 className='dpfu-editor-column-title'>User limits</h3>
            <ConcurrencyLimitColumn
              client={client}
              scope='user'
              entityId={selectedEntity._id}
              operatorId={operatorId}
              disabled={false}
            />
          </div>
          <div className='dpfu-editor-column'>
            <h3 className='dpfu-editor-column-title'>Org limits</h3>
            <ConcurrencyLimitColumn
              client={client}
              scope='org'
              // An organization owner's own user_id IS the org's org_id by construction --
              // see .claude/knowledge/data_pulse/DPI-003, no separate org-id lookup exists.
              entityId={selectedEntity._id}
              operatorId={operatorId}
              disabled={selectedEntity.user_type !== 'organization'}
              disabledMessage="This user isn't an organization — org-level limits don't apply."
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ConcurrencyLimitEditor
